import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove injected badge
function removeBadge() {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
  document.querySelectorAll('a').forEach(a => {
    if (a.href && a.href.includes('emergent') && a.style.cssText.includes('fixed')) {
      a.remove();
    }
  });
}

const observer = new MutationObserver(removeBadge);
observer.observe(document.documentElement, { childList: true, subtree: true });
setInterval(removeBadge, 200);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
